import { Injectable } from "@angular/core";
import { CashRegisterPairingStatusPostDto, CashRegisterParingStatuses } from "cfs-communication-pack";
import { CashRegisterService } from "@app-cmc/services";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
// todo: replace to common project after data and api Services will be moved to common project
export class CashRegisterStatusLoggerService {
  constructor(private cashRegisterService: CashRegisterService) {}

  logSuccessPairing(cashRegisterId: number, message = ""): Observable<void> {
    return this.logPairingStatus(cashRegisterId, CashRegisterParingStatuses.Paired, message);
  }

  logFailedPairing(cashRegisterId: number, message = ""): Observable<void> {
    return this.logPairingStatus(cashRegisterId, CashRegisterParingStatuses.NotPaired, message);
  }

  private logPairingStatus(cashRegisterId: number, status: CashRegisterParingStatuses, message = ""): Observable<void> {
    const postDto: CashRegisterPairingStatusPostDto = { paringStatus: status, message };

    return this.cashRegisterService.setCashRegisterPairingStatus(cashRegisterId, postDto);
  }
}
